import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./LoanOfficer.css";
import htmlParser from "html-react-parser";

const scrollToHelpSectionDesktop = () => {
  const helpSection = document.getElementById("contactus"); // Get the help section element
  const yOffset = -75; // Offset for scrolling

  if (helpSection) {
    const y =
      helpSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

export default function Banner({
  featurenData,
  loanOfficer,
  Contactdata,
  dateTime,
  loInformation,
  loanRealtor,
}) {
  return (
    <>
      <div className="meetdivsf">
        <p className="meetyourhost">Meet Your Hosts</p>
      </div>
      {/* Render inside dynamiclorealtorsection div */}
      <div className="dynamiclorealtorsection">
        <Container>
          <Row className="justify-content-center">
            {loanRealtor ? (
              <Row>
                <Col sm={12} md={12} lg={6} xl={6}>
                  <div className="loddetailsdiv1">
                    <div className="lodetails">
                      <img
                        src={htmlParser(loanOfficer.Image)}
                        className="img-fluid loimgdent"
                        alt="LoanOfficer"
                      ></img>
                      <div className="lodetaidivco">
                        <p className="salvadornametitle">
                          {htmlParser(loanOfficer.Name)}
                        </p>
                        <div className="loseconddetail1">
                          <p>{htmlParser(loanOfficer.NMLSID)}</p>
                          <p>{htmlParser(loanOfficer.Designation)}</p>
                          <p>
                            <a href={"tel:" + loanOfficer.formatPhone}>
                              D: {loanOfficer.Phone}
                            </a>
                          </p>
                          <p>
                            <a
                              href={"mailto:" + loanOfficer.EmailId}
                              title={"Email me at " + loanOfficer.EmailId}
                              aria-label={"Email me at " + loanOfficer.EmailId}
                            >
                              {loanOfficer.EmailId}
                            </a>
                          </p>
                          <p>{htmlParser(loanOfficer.RetailEmailId)}</p>
                          <p>{htmlParser(loanOfficer.branchAddress)}</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className="biotext">{htmlParser(loanOfficer.bio)}</p>
                    </div>
                  </div>
                </Col>

                <Col sm={12} md={12} lg={6} xl={6}>
                  <div className="loddetailsdiv2">
                    <div className="lodetails2">
                      <div className="lodetaidivco">
                        <p className="salvadornametitleco">
                          {htmlParser(loanRealtor.Name)}
                        </p>
                        <div className="loseconddetail">
                          <p>{htmlParser(loanRealtor.NMLSID)}</p>
                          <p>{htmlParser(loanRealtor.Designation)}</p>
                          <p>
                            <a href={"tel:" + loanRealtor.formatPhone}>
                              M: {loanRealtor.Phone}
                            </a>
                          </p>
                          <p>
                            <a
                              href={"mailto:" + loanRealtor.EmailId}
                              title={"Email me at " + loanRealtor.EmailId}
                              aria-label={"Email me at " + loanRealtor.EmailId}
                            >
                              {loanRealtor.EmailId}
                            </a>
                          </p>
                          <p>{htmlParser(loanRealtor.RetailEmailId)}</p>
                          <p>{htmlParser(loanRealtor.branchAddress)}</p>
                        </div>
                      </div>
                      <img
                        src={htmlParser(loanRealtor.Image)}
                        className="img-fluid loimgdent"
                        alt="realtor"
                      ></img>
                    </div>
                    <div>
                      <p className="biotext1">{htmlParser(loanRealtor.bio)}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            ) : (
              // If Realtor data is not available, render Loan Officer section in the center
              <Row className="onlylo-row">
                <div className="onlylodetails d-flex">
                <Col sm={12} md={12} lg={6} xl={6} className="">
                  <div className="lodetailsextra">
                    <div>
                    <img
                      src={htmlParser(loanOfficer.Image)}
                      className="img-fluid loimgdentoptional"
                      alt="LoanOfficer"
                    ></img>
                    </div>
                    <div className="lodetaidiv">
                      <div>
                      <p className="salvadorname">
                        {htmlParser(loanOfficer.Name)}
                      </p>
                      </div>
                      <div className="loseconddetail1">
                        <p>{htmlParser(loanOfficer.NMLSID)}</p>
                        <p>{htmlParser(loanOfficer.Designation)}</p>
                        <p>
                          <a href={"tel:" + loanOfficer.formatPhone}>
                            D: {loanOfficer.Phone}
                          </a>
                        </p>
                        <p>
                          <a
                            href={"mailto:" + loanOfficer.EmailId}
                            title={"Email me at " + loanOfficer.EmailId}
                            aria-label={"Email me at " + loanOfficer.EmailId}
                          >
                            {loanOfficer.EmailId}
                          </a>
                        </p>
                        <p>{htmlParser(loanOfficer.RetailEmailId)}</p>
                        <p>{htmlParser(loanOfficer.branchAddress)}</p>
                        {loanOfficer.calenderlink && (
                          <p className="calenderlinkoflnk">
                            {htmlParser(loanOfficer.calenderlink)}
                          </p>
                        )}
                      </div>
                    </div>
                    </div>
                    </Col>
                    <Col sm={12} md={12} lg={6} xl={6} className="onlylo-bio">
                    <div>
                      <p className="biotext bio-onlylo">{htmlParser(loanOfficer.bio)}</p>
                    </div>
                    </Col>
                    </div>
              </Row>
            )}
          </Row>
        </Container>
      </div>

      <div>
      <div className="disclaimer-container">
      {dateTime.invitemeet.map((text, index) => (
        <p key={index} className="datetimetext">
          {htmlParser(text)}
        </p>
      ))}
      </div>
        {/* <p className="datetimetext">{htmlParser(dateTime.investtitle)}</p>
        <p className="datetimetext1">{htmlParser(dateTime.investseconftitle)}</p>
        <p className="datetimetext2">{htmlParser(dateTime.abovetext)}</p> */}
        <div className="buttonvakground" onClick={scrollToHelpSectionDesktop}>
          {htmlParser(dateTime.buttontext)}
        </div>
        <div className="discgttext">
          <p>{htmlParser(dateTime.disclaimerr)}</p>
        </div>
      </div>
    </>
  );
}
